import { formatCurrency } from "shared/lib/format";
import { TablePlaceholder } from "shared/ui/placeholders";

export default function HistorySummary({
  startDate,
  endDate,
  items,
  onCalendarOpen,
  loading,
  setSelectedModal,
}) {
  const formatDate = (date) =>
    date ? new Date(date).toISOString().split("T")[0] : "YYYY-MM-DD";

  const totalAmount = items.reduce((sum, item) => sum + item.totalAmount, 0);

  return (
    <div className="card">
      <div className="card-body">
        <div className="table-responsive">
          <table className="table mb-0">
            <tbody>
              {loading ? (
                <TablePlaceholder rows={4} count={2} />
              ) : (
                <>
                  <tr>
                    <td className="align-middle">Эхлэх огноо:</td>
                    <td className="align-middle">
                      <div
                        className="form-control"
                        onClick={() => {
                          onCalendarOpen();
                          setSelectedModal("start");
                        }}
                      >
                        {formatDate(startDate)}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="align-middle">Дуусах огноо:</td>
                    <td className="align-middle">
                      <div
                        className="form-control"
                        onClick={() => {
                          onCalendarOpen();
                          setSelectedModal("end");
                        }}
                      >
                        {formatDate(endDate)}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Захиалгын тоо:</td>
                    <td>{items.length}</td>
                  </tr>
                  <tr>
                    <th>Нийт дүн:</th>
                    <th>{formatCurrency(totalAmount)}</th>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
